// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Review.module.scss  */
.Review-module-Root_1nO {
  display: flex;
  flex-direction: column; }

.Review-module-Rating_2oF {
  margin: 0 0 9px; }

.Review-module-Overlay_3XB {
  position: relative;
  margin-bottom: 11px;
  transition: all 0.3s ease; }

.Review-module-Demo_3AO {
  overflow: hidden;
  height: 60px; }
  .Review-module-Demo_3AO::before {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 23px;
    content: '';
    background: linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0) 80.95%); }

.Review-module-Text_2qR {
  margin: 0; }

.Review-module-Skip_3Z6 {
  width: max-content;
  margin: 0 0 16px;
  padding: 0; }
  .Review-module-Skip_3Z6:focus {
    outline: none; }

.Review-module-Name_3Dj {
  margin: 0 0 9px;
  color: #9199a3; }

.Review-module-Data_3Cw {
  margin: 0 0 12px;
  color: #9199a3; }

.Review-module-Counter_3bn {
  display: flex;
  align-items: center; }
  .Review-module-Counter_3bn p {
    margin: 0 23px 0 0; }

.Review-module-Control_2qg {
  max-width: 120px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Review/Review.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB,EAAE;;AAE1B;EACE,eAAe,EAAE;;AAEnB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB,EAAE;;AAE7B;EACE,gBAAgB;EAChB,YAAY,EAAE;EACd;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,2EAA2E,EAAE;;AAEjF;EACE,SAAS,EAAE;;AAEb;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAE;EACZ;IACE,aAAa,EAAE;;AAEnB;EACE,eAAe;EACf,cAAc,EAAE;;AAElB;EACE,gBAAgB;EAChB,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,mBAAmB,EAAE;EACrB;IACE,kBAAkB,EAAE;;AAExB;EACE,gBAAgB,EAAE","sourcesContent":["/*  imported from Review.module.scss  */\n.Review-module-Root_1nO {\n  display: flex;\n  flex-direction: column; }\n\n.Review-module-Rating_2oF {\n  margin: 0 0 9px; }\n\n.Review-module-Overlay_3XB {\n  position: relative;\n  margin-bottom: 11px;\n  transition: all 0.3s ease; }\n\n.Review-module-Demo_3AO {\n  overflow: hidden;\n  height: 60px; }\n  .Review-module-Demo_3AO::before {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 23px;\n    content: '';\n    background: linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0) 80.95%); }\n\n.Review-module-Text_2qR {\n  margin: 0; }\n\n.Review-module-Skip_3Z6 {\n  width: max-content;\n  margin: 0 0 16px;\n  padding: 0; }\n  .Review-module-Skip_3Z6:focus {\n    outline: none; }\n\n.Review-module-Name_3Dj {\n  margin: 0 0 9px;\n  color: #9199a3; }\n\n.Review-module-Data_3Cw {\n  margin: 0 0 12px;\n  color: #9199a3; }\n\n.Review-module-Counter_3bn {\n  display: flex;\n  align-items: center; }\n  .Review-module-Counter_3bn p {\n    margin: 0 23px 0 0; }\n\n.Review-module-Control_2qg {\n  max-width: 120px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
